import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Paperclip = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.5 5.5V10C9.5 10.5 9.2 11.5 8 11.5C6.8 11.5 6.5 10.5 6.5 10V5C6.5 4 7 2 9.25 2C11.5 2 12 4 12 5V10.1667C12 11.25 11.5 14 8 14C4.5 14 4 11.25 4 10.1667V7"
        stroke={stroke || 'currentColor'}
      />
    </svg>
  ),
)
Paperclip.displayName = 'Paperclip'

export default Paperclip
